// extracted by mini-css-extract-plugin
module.exports = {"footer-top":"footer_footer-top__roDOC","footer-bottom":"footer_footer-bottom__3nHuh","contact-us":"footer_contact-us__3KSsY","btn":"footer_btn__3nC0t"};